import type { ColumnsType } from "antd/es/table";

// 默认分页数据
export const DEFAULT_PAGE_DATA = {
    Page: 1,
    PageSize: 10,
    Total: 0,
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "报价ID",
            dataIndex: "quoteId",
            key: "QuoteId",
        },
        {
            title: "货币对",
            dataIndex: "currencyPair",
            key: "CurrencyPair",
        },
        {
            title: "交易类型",
            dataIndex: "transactionType",
            key: "TransactionType",
        },
        {
            title: "买入金额",
            dataIndex: "buyAmount",
            key: "BuyAmount",
        },
        {
            title: "买入货币",
            dataIndex: "BuyCurrency",
            key: "BuyCurrency",
        },
        {
            title: "卖出金额",
            dataIndex: "SellAmount",
            key: "SellAmount",
        },
        {
            title: "卖出货币",
            dataIndex: "SellCurrency",
            key: "SellCurrency",
        },
        {
            title: "参考号",
            dataIndex: "Reference",
            key: "Reference",
        },
        {
            title: "报价日期",
            dataIndex: "ConversionDate",
            key: "ConversionDate",
        },
        {
            title: "创建日期",
            dataIndex: "CreatedDate",
            key: "CreatedDate",
        },
    ];
};
